import { render, staticRenderFns } from "./OrderFulfillmentMessage.vue?vue&type=template&id=32095374&"
import script from "./OrderFulfillmentMessage.vue?vue&type=script&lang=js&"
export * from "./OrderFulfillmentMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports